import {
  fetchLocationHistoryRoutine,
  fetchLocationsRoutine,
  fetchSingleLocationRoutine
} from 'modules/locations/ducks/actions'

const defaultState = {
  list: [],
  currentLocation: {},
  pagination: null,
  locationHistoryList: [],
  locationHistoryListPagination: null,
  isLoading: false,
  isLoadingLocationHistoryList: false,
  isLoadingCurrentLocation: false
}

const locationsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchLocationsRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchLocationsRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchLocationsRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    case fetchSingleLocationRoutine.TRIGGER:
      return {
        ...state,
        isLoadingCurrentLocation: true
      }
    case fetchSingleLocationRoutine.FAILURE:
      return {
        ...state,
        isLoadingCurrentLocation: false
      }
    case fetchSingleLocationRoutine.SUCCESS:
      return {
        ...state,
        currentLocation: action.payload,
        isLoadingCurrentLocation: false
      }
    case fetchLocationHistoryRoutine.TRIGGER:
      return {
        ...state,
        isLoadingLocationHistoryList: true
      }
    case fetchLocationHistoryRoutine.FAILURE:
      return {
        ...state,
        isLoadingLocationHistoryList: false
      }
    case fetchLocationHistoryRoutine.SUCCESS:
      return {
        ...state,
        locationHistoryList: action.payload.data,
        locationHistoryListPagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoadingLocationHistoryList: false
      }
    default:
      return state
  }
}

export default locationsReducer
